var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Basic Tabs")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-1",
            modifiers: {
              "collapse-1": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("The base "), _c('code', [_vm._v(".nav")]), _vm._v(" component does not include any "), _c('code', [_vm._v(".active")]), _vm._v(" state. The following examples include the class, mainly to demonstrate that this particular class does not trigger any special styling.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-1"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "tabs-1"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<tab-nav :tabs=\"true\" id=\"myTab-1\">\n  <tab-nav-items :active=\"true\" id=\"home-tab\" ariaControls=\"home\" role=\"tab\" :ariaSelected=\"true\" title=\"Home\" />\n  <tab-nav-items :active=\"false\" id=\"profile-tab\" ariaControls=\"profile\" role=\"tab\" :ariaSelected=\"false\" title=\"Profile\" />\n  <tab-nav-items :active=\"false\" id=\"contact-tab\" ariaControls=\"contact\" role=\"tab\" :ariaSelected=\"false\" title=\"Contact\" />\n</tab-nav>\n<tab-content id=\"myTabContent\">\n  <tab-content-item :active=\"true\" id=\"home\" aria-labelled-by=\"home-tab\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"profile\" aria-labelled-by=\"profile-tab\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"contact\" aria-labelled-by=\"contact-tab\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n</tab-content>\n")])])])])]), _c('tab-nav', {
          attrs: {
            "tabs": true
          }
        }, [_c('tab-nav-items', {
          attrs: {
            "active": true,
            "id": "home-tab",
            "ariaControls": "home",
            "role": "tab",
            "ariaSelected": true,
            "title": "Home"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "profile-tab",
            "ariaControls": "profile",
            "role": "tab",
            "ariaSelected": false,
            "title": "Profile"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "contact-tab",
            "ariaControls": "contact",
            "role": "tab",
            "ariaSelected": false,
            "title": "Contact"
          }
        })], 1), _c('div', {
          staticClass: "tab-content",
          attrs: {
            "id": "myTabContent"
          }
        }, [_c('tab-content-item', {
          attrs: {
            "active": true,
            "id": "home"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "profile",
            "aria-labelled-by": "profile-tab"
          }
        }, [_c('p', [_vm._v("Profile")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "contact",
            "aria-labelled-by": "contact-tab"
          }
        }, [_c('p', [_vm._v("Contact")])])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Basic Tabs Style 3")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-2",
            modifiers: {
              "collapse-2": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Takes the basic nav from above and adds the "), _c('code', [_vm._v(".nav-tabs")]), _vm._v(" class to generate a tabbed interface.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-2"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "tabs-2"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<tab-nav :tabs=\"true\" id=\"myTab-two\">\n  <tab-nav-items :active=\"true\" id=\"home-tab-two\" ariaControls=\"home\" href=\"#home-two\" role=\"tab\" :ariaSelected=\"true\" title=\"Home\" />\n  <tab-nav-items :active=\"false\" id=\"profile-tab-two\" ariaControls=\"profile\" href=\"#profile-two\" role=\"tab\" :ariaSelected=\"false\" title=\"Profile\" />\n  <tab-nav-items :active=\"false\" id=\"contact-tab-two\" ariaControls=\"contact\" href=\"#contact-two\" role=\"tab\" :ariaSelected=\"false\" title=\"Contact\" />\n</tab-nav>\n<tab-content id=\"myTabContent-1\">\n  <tab-content-item :active=\"true\" id=\"home-two\" aria-labelled-by=\"home-tab-two\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"profile-two\" aria-labelled-by=\"profile-tab-two\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"contact-two\" aria-labelled-by=\"contact-tab-two\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n</tab-content>\n")])])])])]), _c('tab-nav', {
          attrs: {
            "tabs": true,
            "id": "myTab-two"
          }
        }, [_c('tab-nav-items', {
          attrs: {
            "active": true,
            "id": "home-tab-two",
            "ariaControls": "home",
            "href": "#home-two",
            "role": "tab",
            "ariaSelected": true,
            "title": "Home"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "profile-tab-two",
            "ariaControls": "profile",
            "href": "#profile-two",
            "role": "tab",
            "ariaSelected": false,
            "title": "Profile"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "contact-tab-two",
            "ariaControls": "contact",
            "href": "#contact-two",
            "role": "tab",
            "ariaSelected": false,
            "title": "Contact"
          }
        })], 1), _c('tab-content', {
          attrs: {
            "id": "myTabContent-1"
          }
        }, [_c('tab-content-item', {
          attrs: {
            "active": true,
            "id": "home-two",
            "aria-labelled-by": "home-tab-two"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "profile-two",
            "aria-labelled-by": "profile-tab-two"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "contact-two",
            "aria-labelled-by": "contact-tab-two"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Tabs Vertical Pills")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-3",
            modifiers: {
              "collapse-3": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Stack your navigation by changing the flex item direction with the "), _c('code', [_vm._v(".flex-column")]), _vm._v(" utility.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-3"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "tabs-3"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-row>\n  <b-col sm=\"3\">\n    <tab-nav :pills=\"true\" :vertical=\"true\" class=\"text-center\" id=\"v-pills-tab\">\n      <tab-nav-items :active=\"true\" id=\"v-pills-home-tab\" href=\"#v-pills-home\" ariaControls=\"v-pills-home\" role=\"tab\" :ariaSelected=\"true\" title=\"Home\" />\n      <tab-nav-items :active=\"false\" id=\"v-pills-profile-tab\" href=\"#v-pills-profile\" ariaControls=\"v-pills-profile\" role=\"tab\" :ariaSelected=\"false\" title=\"Profile\" />\n      <tab-nav-items :active=\"false\" id=\"v-pills-messages-tab\" href=\"#v-pills-messages\" ariaControls=\"v-pills-messages\" role=\"tab\" :ariaSelected=\"false\" title=\"Messages\" />\n      <tab-nav-items :active=\"false\" id=\"v-pills-settings-tab\" href=\"#v-pills-settings\" ariaControls=\"v-pills-settings\" role=\"tab\" :ariaSelected=\"false\" title=\"Settings\" />\n    </tab-nav>\n  </b-col>\n  <b-col sm=\"9\">\n    <tab-content id=\"v-pills-tabContent\" class=\"mt-0\">\n      <tab-content-item :active=\"true\" id=\"v-pills-home\" aria-labelled-by=\"v-pills-home-tab\">\n        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>\n      </tab-content-item>\n      <tab-content-item :active=\"false\" id=\"v-pills-profile\" aria-labelled-by=\"v-pills-profile-tab\">\n        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>\n      </tab-content-item>\n      <tab-content-item :active=\"false\" id=\"v-pills-messages\" aria-labelled-by=\"v-pills-messages-tab\">\n        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>\n      </tab-content-item>\n        <tab-content-item :active=\"false\" id=\"v-pills-settings\" aria-labelled-by=\"v-pills-settings-tab\">\n          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>\n      </tab-content-item>\n    </tab-content>\n  </b-col>\n</b-row>\n")])])])])]), _c('b-row', [_c('b-col', {
          attrs: {
            "sm": "3"
          }
        }, [_c('tab-nav', {
          staticClass: "text-center",
          attrs: {
            "pills": true,
            "vertical": true,
            "id": "v-pills-tab"
          }
        }, [_c('tab-nav-items', {
          attrs: {
            "active": true,
            "id": "v-pills-home-tab",
            "href": "#v-pills-home",
            "ariaControls": "v-pills-home",
            "role": "tab",
            "ariaSelected": true,
            "title": "Home"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "v-pills-profile-tab",
            "href": "#v-pills-profile",
            "ariaControls": "v-pills-profile",
            "role": "tab",
            "ariaSelected": false,
            "title": "Profile"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "v-pills-messages-tab",
            "href": "#v-pills-messages",
            "ariaControls": "v-pills-messages",
            "role": "tab",
            "ariaSelected": false,
            "title": "Messages"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "v-pills-settings-tab",
            "href": "#v-pills-settings",
            "ariaControls": "v-pills-settings",
            "role": "tab",
            "ariaSelected": false,
            "title": "Settings"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "sm": "9"
          }
        }, [_c('tab-content', {
          staticClass: "mt-0",
          attrs: {
            "id": "v-pills-tabContent"
          }
        }, [_c('tab-content-item', {
          attrs: {
            "active": true,
            "id": "v-pills-home",
            "aria-labelled-by": "v-pills-home-tab"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "v-pills-profile",
            "aria-labelled-by": "v-pills-profile-tab"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "v-pills-messages",
            "aria-labelled-by": "v-pills-messages-tab"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "v-pills-settings",
            "aria-labelled-by": "v-pills-settings-tab"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.")])])], 1)], 1)], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Tabs Justify Center")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-4",
            modifiers: {
              "collapse-4": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Centered with "), _c('code', [_vm._v(".justify-content-center")])]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-4"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "tabs-4"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<tab-nav :tabs=\"true\" id=\"myTab-2\" align=\"center\">\n  <tab-nav-items :active=\"true\" id=\"home-tab-justify\" href=\"#home-justify\" ariaControls=\"home\" role=\"tab\" :ariaSelected=\"true\" title=\"Home\" />\n  <tab-nav-items :active=\"false\" id=\"profile-tab-justify\" href=\"#profile-justify\" ariaControls=\"profile\" role=\"tab\" :ariaSelected=\"false\" title=\"Profile\" />\n  <tab-nav-items :active=\"false\" id=\"contact-tab-justify\" href=\"#contact-justify\" ariaControls=\"contact\" role=\"tab\" :ariaSelected=\"false\" title=\"Contact\" />\n</tab-nav>\n<tab-content id=\"myTabContent-3\">\n  <tab-content-item :active=\"true\" id=\"home-justify\" aria-labelled-by=\"home-tab-justify\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"profile-justify\" aria-labelled-by=\"profile-tab-justify\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"contact-justify\" aria-labelled-by=\"contact-tab-justify\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n</tab-content>\n")])])])])]), _c('tab-nav', {
          attrs: {
            "tabs": true,
            "id": "myTab-2",
            "align": "center"
          }
        }, [_c('tab-nav-items', {
          attrs: {
            "active": true,
            "id": "home-tab-justify",
            "href": "#home-justify",
            "ariaControls": "home",
            "role": "tab",
            "ariaSelected": true,
            "title": "Home"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "profile-tab-justify",
            "href": "#profile-justify",
            "ariaControls": "profile",
            "role": "tab",
            "ariaSelected": false,
            "title": "Profile"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "contact-tab-justify",
            "href": "#contact-justify",
            "ariaControls": "contact",
            "role": "tab",
            "ariaSelected": false,
            "title": "Contact"
          }
        })], 1), _c('tab-content', {
          attrs: {
            "id": "myTabContent-3"
          }
        }, [_c('tab-content-item', {
          attrs: {
            "active": true,
            "id": "home-justify",
            "aria-labelled-by": "home-tab-justify"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "profile-justify",
            "aria-labelled-by": "profile-tab-justify"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "contact-justify",
            "aria-labelled-by": "contact-tab-justify"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Basic Tabs Style 2")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-5",
            modifiers: {
              "collapse-5": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Take that same HTML, but use "), _c('code', [_vm._v(".nav-pills")]), _vm._v(" instead:")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-5"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "tabs-5"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<tab-nav :pills=\"true\" id=\"pills-tab\" class=\"mb-3\">\n  <tab-nav-items :active=\"true\" id=\"pills-home-tab\" href=\"#pills-home\" ariaControls=\"pills-home\" role=\"tab\" :ariaSelected=\"true\" title=\"Home\" />\n  <tab-nav-items :active=\"false\" id=\"pills-profile-tab\" href=\"#pills-profile\" ariaControls=\"pills-profile\" role=\"tab\" :ariaSelected=\"false\" title=\"Profile\" />\n  <tab-nav-items :active=\"false\" id=\"pills-contact-tab\" href=\"#pills-contact\" ariaControls=\"pills-contact\" role=\"tab\" :ariaSelected=\"false\" title=\"Contact\" />\n</tab-nav>\n<tab-content id=\"pills-tabContent-2\">\n  <tab-content-item :active=\"true\" id=\"pills-home\" aria-labelled-by=\"pills-home-tab\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"pills-profile\" aria-labelled-by=\"pills-profile-tab\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"pills-contact\" aria-labelled-by=\"pills-contact-tab\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n</tab-content>\n")])])])])]), _c('tab-nav', {
          staticClass: "mb-3",
          attrs: {
            "pills": true,
            "id": "pills-tab"
          }
        }, [_c('tab-nav-items', {
          attrs: {
            "active": true,
            "id": "pills-home-tab",
            "href": "#pills-home",
            "ariaControls": "pills-home",
            "role": "tab",
            "ariaSelected": true,
            "title": "Home"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "pills-profile-tab",
            "href": "#pills-profile",
            "ariaControls": "pills-profile",
            "role": "tab",
            "ariaSelected": false,
            "title": "Profile"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "pills-contact-tab",
            "href": "#pills-contact",
            "ariaControls": "pills-contact",
            "role": "tab",
            "ariaSelected": false,
            "title": "Contact"
          }
        })], 1), _c('tab-content', {
          attrs: {
            "id": "pills-tabContent-2"
          }
        }, [_c('tab-content-item', {
          attrs: {
            "active": true,
            "id": "pills-home",
            "aria-labelled-by": "pills-home-tab"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "pills-profile",
            "aria-labelled-by": "pills-profile-tab"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "pills-contact",
            "aria-labelled-by": "pills-contact-tab"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Basic Tabs Style 4")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-6",
            modifiers: {
              "collapse-6": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Takes the basic nav from above and adds the "), _c('code', [_vm._v(".nav-tabs")]), _vm._v(" class to generate a tabbed interface.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-6"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "tabs-6"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<tab-nav :tabs=\"true\" id=\"myTab-three\">\n  <tab-nav-items :active=\"true\" id=\"home-tab-three\" ariaControls=\"home\" href=\"#home-three\" role=\"tab\" :ariaSelected=\"true\" title=\"Home\" />\n  <tab-nav-items :active=\"false\" id=\"profile-tab-three\" ariaControls=\"profile\" href=\"#profile-three\" role=\"tab\" :ariaSelected=\"false\" title=\"Profile\" />\n  <tab-nav-items :active=\"false\" id=\"contact-tab-three\" ariaControls=\"contact\" href=\"#contact-three\" role=\"tab\" :ariaSelected=\"false\" title=\"Contact\" />\n</tab-nav>\n<tab-content id=\"myTabContent-4\">\n  <tab-content-item :active=\"true\" id=\"home-three\" aria-labelled-by=\"home-tab-three\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"profile-three\" aria-labelled-by=\"profile-tab-three\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"contact-three\" aria-labelled-by=\"contact-tab-three\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n</tab-content>\n")])])])])]), _c('tab-nav', {
          attrs: {
            "tabs": true,
            "id": "myTab-three"
          }
        }, [_c('tab-nav-items', {
          attrs: {
            "active": true,
            "id": "home-tab-three",
            "ariaControls": "home",
            "href": "#home-three",
            "role": "tab",
            "ariaSelected": true,
            "title": "Home"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "profile-tab-three",
            "ariaControls": "profile",
            "href": "#profile-three",
            "role": "tab",
            "ariaSelected": false,
            "title": "Profile"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "contact-tab-three",
            "ariaControls": "contact",
            "href": "#contact-three",
            "role": "tab",
            "ariaSelected": false,
            "title": "Contact"
          }
        })], 1), _c('tab-content', {
          attrs: {
            "id": "myTabContent-4"
          }
        }, [_c('tab-content-item', {
          attrs: {
            "active": true,
            "id": "home-three",
            "aria-labelled-by": "home-tab-three"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "profile-three",
            "aria-labelled-by": "profile-tab-three"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "contact-three",
            "aria-labelled-by": "contact-tab-three"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Tabs Fills and justify")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-7",
            modifiers: {
              "collapse-7": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Force your "), _c('code', [_vm._v(".nav")]), _vm._v("’s contents to extend the full available width one of two modifier classes. To proportionately fill all available space with your "), _c('code', [_vm._v(".nav-item")]), _vm._v("s, use "), _c('code', [_vm._v(".nav-fill")]), _vm._v(". Notice that all horizontal space is occupied, but not every nav item has the same width.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-7"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "tabs-7"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<tab-nav :pills=\"true\" class=\"nav-fill mb-3\" id=\"pills-tab-1\">\n  <tab-nav-items :active=\"true\" id=\"pills-home-tab-fill\" href=\"#pills-home-fill\" ariaControls=\"pills-home-fill\" role=\"tab\" :ariaSelected=\"true\" title=\"Home\" />\n  <tab-nav-items :active=\"false\" id=\"pills-profile-tab-fill\" href=\"#pills-profile-fill\" ariaControls=\"pills-profile-fill\" role=\"tab\" :ariaSelected=\"false\" title=\"Profile\" />\n  <tab-nav-items :active=\"false\" id=\"pills-contact-tab-fill\" href=\"#pills-contact-fill\" ariaControls=\"pills-contact-fill\" role=\"tab\" :ariaSelected=\"false\" title=\"Contact\" />\n</tab-nav>\n<tab-content id=\"pills-tabContent-1\" class=\"mt-0\">\n  <tab-content-item :active=\"true\" id=\"pills-home-fill\" aria-labelled-by=\"pills-home-tab-fill\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"pills-profile-fill\" aria-labelled-by=\"pills-profile-tab-fill\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"pills-contact-fill\" aria-labelled-by=\"pills-contact-tab-fill\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>\n  </tab-content-item>\n</tab-content>\n")])])])])]), _c('tab-nav', {
          staticClass: "nav-fill mb-3",
          attrs: {
            "pills": true,
            "id": "pills-tab-1"
          }
        }, [_c('tab-nav-items', {
          attrs: {
            "active": true,
            "id": "pills-home-tab-fill",
            "href": "#pills-home-fill",
            "ariaControls": "pills-home-fill",
            "role": "tab",
            "ariaSelected": true,
            "title": "Home"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "pills-profile-tab-fill",
            "href": "#pills-profile-fill",
            "ariaControls": "pills-profile-fill",
            "role": "tab",
            "ariaSelected": false,
            "title": "Profile"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "pills-contact-tab-fill",
            "href": "#pills-contact-fill",
            "ariaControls": "pills-contact-fill",
            "role": "tab",
            "ariaSelected": false,
            "title": "Contact"
          }
        })], 1), _c('tab-content', {
          staticClass: "mt-0",
          attrs: {
            "id": "pills-tabContent-1"
          }
        }, [_c('tab-content-item', {
          attrs: {
            "active": true,
            "id": "pills-home-fill",
            "aria-labelled-by": "pills-home-tab-fill"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "pills-profile-fill",
            "aria-labelled-by": "pills-profile-tab-fill"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "pills-contact-fill",
            "aria-labelled-by": "pills-contact-tab-fill"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.")])])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Tabs Justify Center")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-8",
            modifiers: {
              "collapse-8": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Right-aligned with "), _c('code', [_vm._v(".justify-content-end")]), _vm._v(".")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-8"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "tabs-8"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<tab-nav :tabs=\"true\" id=\"myTab-4\" align=\"end\">\n  <tab-nav-items :active=\"true\" id=\"home-tab-end\" href=\"#home-end\" ariaControls=\"home\" role=\"tab\" :ariaSelected=\"true\" title=\"Home\" />\n  <tab-nav-items :active=\"false\" id=\"profile-tab-end\" href=\"#profile-end\" ariaControls=\"profile\" role=\"tab\" :ariaSelected=\"false\" title=\"Profile\" />\n  <tab-nav-items :active=\"false\" id=\"contact-tab-end\" href=\"#contact-end\" ariaControls=\"contact\" role=\"tab\" :ariaSelected=\"false\" title=\"Contact\" />\n</tab-nav>\n<tab-content id=\"myTabContent-5\">\n  <tab-content-item :active=\"true\" id=\"home-end\" aria-labelled-by=\"home-tab-end\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"profile-end\" aria-labelled-by=\"profile-tab-end\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n  <tab-content-item :active=\"false\" id=\"contact-end\" aria-labelled-by=\"contact-tab-end\">\n    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>\n  </tab-content-item>\n</tab-content>\n")])])])])]), _c('tab-nav', {
          attrs: {
            "tabs": true,
            "id": "myTab-4",
            "align": "end"
          }
        }, [_c('tab-nav-items', {
          attrs: {
            "active": true,
            "id": "home-tab-end",
            "href": "#home-end",
            "ariaControls": "home",
            "role": "tab",
            "ariaSelected": true,
            "title": "Home"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "profile-tab-end",
            "href": "#profile-end",
            "ariaControls": "profile",
            "role": "tab",
            "ariaSelected": false,
            "title": "Profile"
          }
        }), _c('tab-nav-items', {
          attrs: {
            "active": false,
            "id": "contact-tab-end",
            "href": "#contact-end",
            "ariaControls": "contact",
            "role": "tab",
            "ariaSelected": false,
            "title": "Contact"
          }
        })], 1), _c('tab-content', {
          attrs: {
            "id": "myTabContent-5"
          }
        }, [_c('tab-content-item', {
          attrs: {
            "active": true,
            "id": "home-end",
            "aria-labelled-by": "home-tab-end"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "profile-end",
            "aria-labelled-by": "profile-tab-end"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])]), _c('tab-content-item', {
          attrs: {
            "active": false,
            "id": "contact-end",
            "aria-labelled-by": "contact-tab-end"
          }
        }, [_c('p', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")])])], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }